import { createSlice } from "@reduxjs/toolkit";
import { clearAlertDispatch } from "../dispatch/alert/clear-alert";
import { loadOldAlerts } from "../dispatch/alert/load-old-alert";
import { setAlertDispatch } from "../dispatch/alert/set-alert";
import { setOldDelayAlertDispatch } from "../dispatch/alert/set-old-delay-alert";
import { setOldExpectedDelayAlertDispatch } from "../dispatch/alert/set-old-expected-delay-alert";
import { setOldNotStartedAlertDispatch } from "../dispatch/alert/set-old-not-started-alert";
import { setOldWithoutPhotoAlertDispatch } from "../dispatch/alert/set-old-without-photo-alert";
import { RootState } from "../store";
import { AlertState } from "../type/alert-state";

const initialState: AlertState = {
  oldAlerts: {
    schedulesNotStarted: [],
    deliveryGroupsExpectedToBeDelayed: [],
    deliveryGroupsCompletedWithDelay: [],
    deliveryGroupsCompletedWithoutImage: [],
  },
  allAlerts: {
    schedulesNotStarted: [],
    deliveryGroupsExpectedToBeDelayed: [],
    deliveryGroupsCompletedWithDelay: [],
    deliveryGroupsCompletedWithoutImage: [],
  },
  status: "idle",
};

export const alertSlice = createSlice({
  name: "alertSlice",
  initialState,
  reducers: {
    setAlertAction: setAlertDispatch,
    clearAlertAction: clearAlertDispatch,
    setOldNotStartedAlertAction: setOldNotStartedAlertDispatch,
    setOldExpectedDelayAlertAction: setOldExpectedDelayAlertDispatch,
    setOldDelayAlertAction: setOldDelayAlertDispatch,
    setOldWithoutPhotoAlertAction: setOldWithoutPhotoAlertDispatch,
  },
  extraReducers: (builder) => {
    builder.addCase(loadOldAlerts.fulfilled, (state, action) => {
      state.oldAlerts = action.payload;
      state.status = "idle";
    })
        .addCase(loadOldAlerts.pending, (state) => {
          state.status = "loading";
        })
        .addCase(loadOldAlerts.rejected, (state) => {
          state.status = "failed";
        });
  }
});

export const {
  setAlertAction,
  clearAlertAction,
  setOldNotStartedAlertAction,
  setOldExpectedDelayAlertAction,
  setOldDelayAlertAction,
  setOldWithoutPhotoAlertAction,
} = alertSlice.actions;

export const loadOldAlertAction = loadOldAlerts;

export const alertState = (state: RootState) => state.alert;

export default alertSlice.reducer;
